import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { encryptedStorage } from 'src/utils/storage'

export type User = {
  Id: string
  Email: string
  Phone: string
  UserName: string
  CompanyId: string
  CompanyCode: string
  CompanyName: string
  UserStatusId: string
  ExtranetUser: boolean
}

type UsersStore = {
  users: User[]
  resetUsers: () => void
  setUsers: (users: User[]) => void
  updateUserStored: (user: User) => void
  findUserById: (id: string) => User | undefined
}

export const useUsersStore = create<UsersStore>()(
  persist(
    (set, get) => ({
      users: [],
      resetUsers: () => set(() => ({ users: [] })),
      setUsers: (users: User[]) => set(() => ({ users })),
      findUserById: (id: string) => {
        const { users } = get()
        return users.find((user: User) => user.Id === id)
      },
      updateUserStored: (user: User) =>
        set((state) => ({
          users: state.users.map((el) => {
            if (el.Id === user.Id) {
              return user
            }
            return el
          }),
        })),
    }),
    {
      name: 'users-storage',
      storage: encryptedStorage(),
    }
  )
)
